import store from '@/store'
import i18n from '@/libs/i18n'

const staticModulde = store.state.staticModule

export default {
  getOrgTypeCountByType: state => type => state.orgCountByTypeAndOrgAdmin.find(orgType => orgType.type_org_id === type),
  getOrgCountByRegionAndTypeForBarChart: state => {
    const data = state.orgCountByRegionAndType
    const labels = []
    const datasetDataOTM = []
    const datasetDataITM = []
    data.forEach(item => {
      labels.push(item.name[i18n.locale])
      datasetDataOTM.push(Number(item[staticModulde.orgTypeOTM]))
      datasetDataITM.push(Number(item[staticModulde.orgTypeITM]))
    })
    return {
      labels,
      datasets: [
        {
          label: store.getters['staticModule/getOrgType'](staticModulde.orgTypeOTM).name[i18n.locale], data: datasetDataOTM, borderColor: 'transparent', backgroundColor: '#28dac6',
        },
        {
          label: store.getters['staticModule/getOrgType'](staticModulde.orgTypeITM).name[i18n.locale], data: datasetDataITM, borderColor: 'transparent', backgroundColor: '#836AF9',
        },
      ],
    }
  },
}
